import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";

const FIELDS = [
  { key: "NUCLEO",                    label: "Nome do Núcleo" },
  { key: "NM_CERURB",                 label: "Nome CERURB" },
  // { key: "NUCLEO_CASALEGAL_PAINEIS",  label: "Núcleo Casa Legal / Painéis" },
];

export default function NucleoEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [original, setOriginal] = useState(null);
  const [form, setForm]         = useState({});
  const [loading, setLoading]   = useState(true);
  const [saving, setSaving]     = useState(false);
  const [error, setError]       = useState(null);
  const [success, setSuccess]   = useState(false);

  const API_URL = process.env.REACT_APP_API_URL;
  const API_KEY = process.env.REACT_APP_API_KEY;
  const headers = { Authorization: `Bearer ${API_KEY}` };

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        const res = await axios.get(`${API_URL}/dados/nucleos/${id}`, { headers });
        const d = res.data.data;
        setOriginal(d);
        setForm({
          NUCLEO:                   d.NUCLEO || "",
          NM_CERURB:                d.NM_CERURB || "",
          // NUCLEO_CASALEGAL_PAINEIS: d.NUCLEO_CASALEGAL_PAINEIS || "",
        });
      } catch {
        setError("Erro ao carregar dados do núcleo.");
      } finally {
        setLoading(false);
      }
    };
    load();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleSave = async () => {
    setSaving(true);
    setError(null);
    setSuccess(false);
    try {
      await axios.put(`${API_URL}/dados/nucleos/${id}`, form, { headers });
      setSuccess(true);
      setOriginal(prev => ({ ...prev, ...form }));
    } catch {
      setError("Erro ao salvar. Tente novamente.");
    } finally {
      setSaving(false);
    }
  };

  const hasChanges = original && FIELDS.some(f => form[f.key] !== (original[f.key] || ""));

  if (loading) return <PageShell><p style={{ color: "#666" }}>Carregando...</p></PageShell>;

  return (
    <PageShell>
      {/* Cabeçalho */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 24 }}>
        <button onClick={() => navigate(-1)} style={backBtnStyle}>← Voltar</button>
        <h2 style={{ margin: 0, fontSize: 18, color: "#1976d2" }}>Editar Núcleo</h2>
      </div>

      {/* Info somente leitura */}
      {original && (
        <div style={{ display: "flex", gap: 24, marginBottom: 24, padding: "12px 16px", background: "#e3f2fd", borderRadius: 6, flexWrap: "wrap" }}>
          <InfoItem label="Município"  value={original.municipio} />
          <InfoItem label="Território" value={original.territorio} />

        </div>
      )}

      {/* Formulário */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px 24px" }}>
        {FIELDS.map(({ key, label }) => (
          <div key={key}>
            <label style={{ display: "block", fontSize: 12, color: "#555", marginBottom: 4 }}>
              {label}
            </label>
            <input
              value={form[key]}
              onChange={e => setForm(prev => ({ ...prev, [key]: e.target.value }))}
              style={inputStyle}
            />
          </div>
        ))}
      </div>

      {/* Feedback */}
      {error   && <div style={alertStyle("#ffebee", "#c62828")}>{error}</div>}
      {success && <div style={alertStyle("#e8f5e9", "#2e7d32")}>Salvo com sucesso!</div>}

      {/* Botões */}
      <div style={{ display: "flex", gap: 10, marginTop: 28, justifyContent: "flex-end" }}>
        <button onClick={() => navigate(-1)} style={btnStyle("#757575")} disabled={saving}>
          Cancelar
        </button>
        <button
          onClick={handleSave}
          style={btnStyle(hasChanges ? "#1976d2" : "#90a4ae")}
          disabled={saving || !hasChanges}
        >
          {saving ? "Salvando..." : "Salvar alterações"}
        </button>
      </div>

    </PageShell>
  );
}

function PageShell({ children }) {
  return (
    <div style={{
      minHeight: "100vh",
      background: "#f5f5f5",
      display: "flex",
      justifyContent: "center",
      padding: "40px 16px",
    }}>
      <div style={{
        width: "100%",
        maxWidth: 700,
        background: "#fff",
        borderRadius: 8,
        padding: 32,
        boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
        height: "fit-content",
      }}>
        {children}
      </div>
    </div>
  );
}

function InfoItem({ label, value, small }) {
  return (
    <div>
      <div style={{ fontSize: 11, color: "#1565c0", fontWeight: "bold", marginBottom: 2 }}>{label}</div>
      <div style={{ fontSize: small ? 12 : 14, color: "#333" }}>{value || "—"}</div>
    </div>
  );
}

const inputStyle = {
  width: "100%",
  boxSizing: "border-box",
  padding: "8px 10px",
  border: "1px solid #ccc",
  borderRadius: 4,
  fontSize: 14,
  outline: "none",
};

const backBtnStyle = {
  padding: "6px 14px",
  background: "none",
  border: "1px solid #1976d2",
  color: "#1976d2",
  borderRadius: 4,
  cursor: "pointer",
  fontSize: 13,
};

const btnStyle = (bg) => ({
  padding: "8px 20px",
  background: bg,
  color: "#fff",
  border: "none",
  borderRadius: 4,
  cursor: "pointer",
  fontSize: 14,
});

const alertStyle = (bg, color) => ({
  marginTop: 16,
  padding: "10px 14px",
  background: bg,
  color,
  borderRadius: 4,
  fontSize: 13,
});
